module.exports = __webpack_public_path__ + "static/img/logo_hq.67bde32.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_hq.png
// module id = 1048
// module chunks = 1